export class UiErrorMessage extends Error {
  constructor(public uiMessage: string, public originalError?: any) {
    // Chiamiamo il costruttore di Error in modo semplice
    super(uiMessage);
    
    // Assicuriamoci che il nome della classe sia corretto
    this.name = 'UiErrorMessage';
    
    // Necessario per far funzionare instanceof in IE
    Object.setPrototypeOf(this, UiErrorMessage.prototype);
  }
}
